import React, { useState } from "react";
import "./projets.css";
import { ProjectData } from "../../Data/Projects";
import ProjectCard from "./Project-Card";
import Separator from "../../../Common/Separator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faSpinner } from "@fortawesome/free-solid-svg-icons";

function Projets() {
  const data = ProjectData;

  const [noOfElement, setnoOfElement] = useState(2);

  const loadMore = () => {
    setnoOfElement(noOfElement + noOfElement);
  };

  const slice = data.slice(0, noOfElement);
  return (
    <div className="projects">
      <Separator />
      <label className="section-title">Projects</label>
      <div>
        {slice.map((project) => {
          return <ProjectCard project={project} />;
        })}

          <button className="load-more" onClick={() => 
            loadMore()}     >
            {" "}
            
            {/* <FontAwesomeIcon icon={faSpinner} spin size="lg" style={{color: "#776AE8",}} /> */}
            
            <div className="arrow">
            <FontAwesomeIcon icon={faArrowDown} size="2xl" bounce />
            </div>

            <div class="loader">
              {/* <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div> */}
            </div>
          </button>
        </div>
    </div>
  );
}

export default Projets;
